import { ShipmentStage } from "./types";

export const SWAG_BAG_ARRIVAL_DEADLINE = "2026-08-22";
export const GENERAL_EVENT_SWAG_ARRIVAL_DEADLINE = "2026-09-17";

export const SHIPPING_ADDRESS = {
  recipient: "Hack the North",
  careOf: "Kari Griffiths",
  fullName: "Hack the North c/o Kari Griffiths",
  roomUnit: "PSE 7341",
  organization: "University of Waterloo",
  streetAddress: "263 Phillip Street",
  city: "Waterloo",
  province: "ON (Ontario)",
  postalCode: "N2L 3G1",
  country: "Canada",
} as const;

export type ShippingAddressField = {
  key: keyof typeof SHIPPING_ADDRESS;
  label: string;
  helperText?: string;
  width: "full" | "half" | "third" | "quarter";
};

export const SHIPPING_ADDRESS_FIELDS: ShippingAddressField[] = [
  { key: "recipient", label: "Recipient / Addressee", width: "half" },
  { key: "careOf", label: "Care of (c/o)", width: "half" },
  {
    key: "fullName",
    label: "Full name",
    helperText:
      "Use this if your carrier doesn't have enough boxes for Recipient and Care Of to be separate",
    width: "half",
  },
  { key: "organization", label: "Organization", width: "half" },
  { key: "streetAddress", label: "Street address", width: "half" },
  { key: "roomUnit", label: "Room / Office / Unit", width: "half" },
  { key: "city", label: "City", width: "quarter" },
  { key: "province", label: "Province", width: "quarter" },
  { key: "postalCode", label: "Postal code", width: "quarter" },
  { key: "country", label: "Country", width: "quarter" },
];

export const SHIPMENT_STAGE_LABELS: Record<ShipmentStage, string> = {
  draft: "Draft",
  shipped: "Shipped",
  partially_received: "Partially received",
  received: "Received",
  packed: "Packed",
};
